import ReportsDeliveryScheduleState from '@app/model/review/delivery/ReportsDeliveryScheduleState';
import ReportsDeliveryScheduleType from '@app/model/review/delivery/ReportsDeliveryScheduleType';
import WeekDay from '@app/model/review/delivery/WeekDay';

export default class ReportsDeliverySchedule {
	id?: number;
	companyHotelId: number;
	creationDate?: string;
	state: ReportsDeliveryScheduleState;
	recipients: string[];
	dayOfMonth?: number;
	weekdays: WeekDay[];
	time?: string;
	scheduleType: ReportsDeliveryScheduleType;
	reportIds: number[];
	nextExecutionDate?: string;
	timezone?: string;

	constructor(data: ReportsDeliverySchedule) {
		this.id = data.id;
		this.companyHotelId = data.companyHotelId;
		this.creationDate = data.creationDate;
		this.state = data.state;
		this.recipients = data.recipients ?? [];
		this.dayOfMonth = data.dayOfMonth;
		this.weekdays = data.weekdays ?? [];
		this.time = data.time;
		this.scheduleType = data.scheduleType;
		this.reportIds = data.reportIds ?? [];
		this.nextExecutionDate = data.nextExecutionDate;
		this.timezone = data.timezone;
	}

	get isActive(): boolean {
		return this.state === ReportsDeliveryScheduleState.ACTIVE;
	}
}
